import Vue3Spline from 'vue3-spline';
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(Vue3Spline);
});
